import { useSession } from "0.Mine/2.Context/sessionContext";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useHandleImageUpload = () => {
  const navigate = useNavigate();
  const { session } = useSession();

  useEffect(() => {
    if (!session) {
      navigate("/signin", { replace: true });
    }
    if (!session?.user) {
      navigate("/signin", { replace: true });
    }
  });

  const uploadImage = async (image: any, type: string, businessid: string) => {
    const formData = new FormData();
    formData.append("image", image);
    formData.append("type", type);
    formData.append("userid", session.user.id);
    formData.append("businessid", businessid);
    formData.append("token", session.user.token);

    try {
      const response = await fetch("https://api.qlickup.it/V1/POST/upload.php", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log(result);
      return result.url;
    } catch (error) {
      console.error(error);
    }
  };

  const uploadImageService = async (image: any, serviceid: string, businessid: string) => {
    const formData = new FormData();
    formData.append("image", image);
    formData.append("type", "services");
    formData.append("userid", session.user.id);
    formData.append("serviceid", serviceid);
    formData.append("businessid", businessid);
    formData.append("token", session.user.token);

    console.log(formData);
    try {
      const response = await fetch("https://api.qlickup.it/V1/POST/upload.php", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.url;
    } catch (error) {
      console.error(error);
    }
  };

  const uploadImageEmployee = async (image: any, employeeId: string, businessid: string) => {
    const formData = new FormData();
    formData.append("image", image);
    formData.append("type", "collaborator");
    formData.append("userid", session.user.id);
    formData.append("collaboratorid", employeeId);
    formData.append("businessid", businessid);
    formData.append("token", session.user.token);

    try {
      const response = await fetch("https://api.qlickup.it/V1/POST/upload.php", {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      return result.url;
    } catch (error) {
      console.error(error);
    }
  };

  return { uploadImage, uploadImageService, uploadImageEmployee };
};
